import { Component } from 'react';
import i18n from '../i18n';
import ErrorPage from './ErrorPage';

// If a page crashes while drawing, React would otherwise leave the visitor
// with a blank white screen. This catches it and shows a short message with
// a way out instead. Going to another address (resetKey) clears the error,
// so the rest of the site keeps working.
//
// A class, because only a class component can catch render errors.
class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Shows up in the browser console - and in any monitoring added later.
    console.error('Page crashed:', error, info.componentStack);
  }

  componentDidUpdate(previous) {
    if (this.state.error && previous.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return <ErrorPage title={i18n.t('crash.title')} body={i18n.t('crash.body')} reload />;
  }
}

export default ErrorBoundary;
